import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Button } from '../../components/Button';
import { copy } from '../../helpers/copy';
import { QUEST_PROGRAMS, QUEST_STATUSES, QUEST_TYPES } from '../../helpers/quests';
import { getUser } from '../../store/userSlice/selectors';
import { useCountdown } from '../../helpers/hooks/useCountdown';

const NextCheckIn = ({ date }) => {
  const { t } = useTranslation();
  const { hours, minutes } = useCountdown(date);
  return (
    <span className="text-[1.2rem] text-white-500 whitespace-nowrap">
      {t('quests.hold.nextCheck', { hours, minutes })}
    </span>
  );
};

export const QuestAction = ({ quest, data, pendingAction, onClaim, onCheckHold, size = 'md' }) => {
  const { t } = useTranslation();
  const currentUser = useSelector(getUser);
  const buttonClass = size === 'sm' ? 'h-[3.2rem] text-[1.2rem] font-500' : 'h-[4rem] text-[1.4rem] font-500';

  if (quest.status === QUEST_STATUSES.CLAIMED) {
    return <span className="text-[1.3rem] font-500 text-green whitespace-nowrap">{t('quests.status.claimed')}</span>;
  }

  // Gold можно забрать только после выполнения основных заданий
  if (quest.isGold && quest.status === QUEST_STATUSES.COMPLETED && data && !data.goldUnlocked) {
    return (
      <span className="text-[1.2rem] font-500 text-[#FFC24B] whitespace-nowrap">{t('quests.gold.lockedAction')}</span>
    );
  }

  if (quest.status === QUEST_STATUSES.COMPLETED) {
    return (
      <Button
        type="green"
        loadingType="black"
        className={buttonClass}
        loading={pendingAction === `claim-${quest.id}`}
        disabled={!!pendingAction}
        onClick={() => onClaim(quest.id)}
      >
        {t('quests.actions.claim', { points: quest.points })}
      </Button>
    );
  }

  if (quest.effectiveType === QUEST_TYPES.UPGRADE) {
    return (
      <Link to={QUEST_PROGRAMS[quest.program]?.route ?? '/dashboard'}>
        <Button type="gray" className={buttonClass}>
          {t('quests.actions.upgrade')}
        </Button>
      </Link>
    );
  }

  // Рециклы приходят от активности в матрицах: ведём к программам
  if ([QUEST_TYPES.RECYCLE, QUEST_TYPES.GOLD_RECYCLE, QUEST_TYPES.COMBO].includes(quest.effectiveType)) {
    return (
      <Link to="/dashboard">
        <Button type="gray" className={buttonClass}>
          {t('quests.actions.programs')}
        </Button>
      </Link>
    );
  }

  if (quest.effectiveType === QUEST_TYPES.HOLD) {
    if (data?.holdCheckedToday) {
      return <NextCheckIn date={data.nextHoldCheckAt} />;
    }
    return (
      <Button
        type="purple"
        loadingType="white"
        className={buttonClass}
        loading={pendingAction === 'hold'}
        disabled={!!pendingAction}
        onClick={onCheckHold}
      >
        {t('quests.actions.checkHold')}
      </Button>
    );
  }

  return (
    <Button
      type="gray"
      className={buttonClass}
      disabled={!currentUser?.refNumber}
      onClick={() => copy(`https://polynetica.com/r/${currentUser.refNumber}`)}
    >
      {t('quests.actions.copyLink')}
    </Button>
  );
};
